import { render } from "./UserOrdini.vue?vue&type=template&id=5bc5d80a&scoped=true"
import script from "./UserOrdini.vue?vue&type=script&lang=js"
export * from "./UserOrdini.vue?vue&type=script&lang=js"

import "./UserOrdini.vue?vue&type=style&index=0&id=5bc5d80a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc5d80a"]])

export default __exports__